// MobileFilterStrip — Deck-Leiste der mobilen Ansicht: Suche mit Syntax-Hilfe,
// Gruppieren und Sortieren. Der Master dockt sie unter 900px selbst am unteren
// Rand an; `dockBar` ist die Zeile darüber (Editor- bzw. Auswahl-Aktionen).
import React from 'react';
import FilterStrip from '../../../../ui/FilterStrip';
import SyntaxHelpPopover from '../../../../ui/SyntaxHelpPopover';
import { GROUPING_STRATEGIES } from '../../utils/groupingStrategies';
import { SORT_OPTIONS } from '../../hooks/useDeckFiltering';

const GROUPING_OPTIONS = Object.values(GROUPING_STRATEGIES).map((s) => ({
  value: s.key,
  label: s.label,
}));

const SORT_MENU_OPTIONS = SORT_OPTIONS.map((o) => ({ value: o.value, label: o.label }));

export default function MobileFilterStrip({
  searchTerm,
  onSearchTermChange,
  sortBy,
  onSortByChange,
  groupingMode,
  onGroupingModeChange,
  dockBar = null,
}) {
  return (
    <FilterStrip>
      <FilterStrip.Search
        value={searchTerm}
        onChange={onSearchTermChange}
        placeholder="Im Deck suchen…"
        help={<SyntaxHelpPopover />}
      />
      <FilterStrip.RightGroup>
        <FilterStrip.Item id="gruppieren">
          <FilterStrip.Group label="Gruppieren">
            <FilterStrip.PillMenu
              mode="single"
              options={GROUPING_OPTIONS}
              value={groupingMode}
              onChange={onGroupingModeChange}
            />
          </FilterStrip.Group>
        </FilterStrip.Item>
        <FilterStrip.Item id="sortierung">
          <FilterStrip.Group label="Sortierung">
            <FilterStrip.PillMenu
              mode="single"
              options={SORT_MENU_OPTIONS}
              value={sortBy}
              onChange={onSortByChange}
            />
          </FilterStrip.Group>
        </FilterStrip.Item>
      </FilterStrip.RightGroup>
      {dockBar ? <FilterStrip.DockBar>{dockBar}</FilterStrip.DockBar> : null}
    </FilterStrip>
  );
}
